module.exports = __webpack_public_path__ + "img/octopus-2.46868e8e.png";